import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_OCTOPUS_AUTO_AA_ML_DIGEST_CONFIG = createFcmDetails('octopus_auto_aa_ml_digest_config', {
	owner: 'Site Platform',
	context: 'comms stack',
	description:
		'Template experiment config for auto_aa_ml message type. Defines experiments used for the auto_aa_ml_digest template. Leave the constraints empty [], to enable the experiment for all countries.',
	import: false,
	template: {
		name: '<experiment_name>',
		constraints: ['AR', 'AU', 'BR', 'CA', 'DE', 'ES', 'FR', 'GB', 'ID', 'IN', 'IT', 'JP', 'MX', 'TH', 'TR', 'US'],
	},
});
